export default __webpack_public_path__ + "static/service-icon4-2ef361c31dedbb6f5edb8679b3f3cc3c.png";